import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { useSessionCalcData, useSessionSummary, useInvalidateSession } from '../../hooks/useSessions';
import SessionDetails from './SessionDetails/SessionDetails';

export default function SessionView(): ReactElement {
  const { sessionId } = useParams();

  if (!sessionId) {
    return <div>Missing session id!</div>;
  }

  if (sessionId === 'new') {
    return <NewSessionDetails />;
  }

  return <ExistingSessionDetails sessionId={sessionId} />;
}

const NewSessionDetails = () => {
  const handleRefetch = async () => {
    // No-op for new sessions
  };

  return (
    <SessionDetails
      sessionId={'new'}
      session={{}}
      isSessionPending={false}
      isSessionFetching={false}
      isNew={true}
      refetchSession={handleRefetch}
    />
  );
};

const ExistingSessionDetails = ({ sessionId }: { sessionId: string }) => {
  // Phase 1: light summary drives the config/run list — paints first.
  const { data: summary, isPending: isSummaryPending, isFetching: isSummaryFetching } = useSessionSummary(sessionId);
  // Phase 2: full payload for plots — fetched in parallel but no longer gates the list.
  const { data: full, isPending: isFullPending, isFetching: isFullFetching } = useSessionCalcData(sessionId);
  const invalidateSession = useInvalidateSession(sessionId);

  return (
    <SessionDetails
      sessionId={sessionId}
      session={summary}
      isSessionPending={isSummaryPending}
      isSessionFetching={isSummaryFetching}
      fullSession={full}
      isFullPending={isFullPending}
      isFullFetching={isFullFetching}
      isNew={false}
      refetchSession={invalidateSession}
    />
  );
};
